import * as mealControl from './mealControl'
import * as auth from './auth'
import * as students from './students'
import * as forms from './forms'
import * as responsible from './responsible'
import * as siblings from './siblings'
import * as emergencyContact from './emergencyContact'
import * as responsibleMenu from './menu'

export {
  mealControl,
  auth,
  students,
  forms,
  responsible,
  siblings,
  emergencyContact,
  responsibleMenu
}
